export default {
  LOGIN: '/login',
  HOME: '/',
  CHECKOUT: '/pay/:uuid',
  CHECKOUT_V2: '/pay/v2/:uuid',
  SURA_CHECKOUT: '/sura/pay/:paymentLinkId/payment-methods',
  SURA_CHECKOUT_ONLINEPAYMENT: '/sura/pay/:paymentLinkId/payment-methods/online-payment',
  SURA_CHECKOUT_ONLINEPAYMENT_CARDVISA:
    '/sura/pay/:paymentLinkId/payment-methods/online-payment/card/visa-mastercard',
  SURA_CHECKOUT_ONLINEPAYMENT_CARDAMEX:
    '/sura/pay/:paymentLinkId/payment-methods/online-payment/card/amex',
  SURA_CHECKOUT_ONLINEPAYMENT_CLABE:
    '/sura/pay/:paymentLinkId/payment-methods/online-payment/direct-debit',
  SURA_CHECKOUT_CASH: '/sura/pay/:paymentLinkId/payment-methods/shared',
  SURA_CHECKOUT_BANK_REFERENCE: '/sura/pay/:paymentLinkId/payment-methods/bank-reference',
  SURA_CHECKOUT_BANK_REFERENCE_SENDREFERENCE:
    '/sura/pay/:paymentLinkId/payment-methods/bank-reference/send-reference',
  SURA_CHECKOUT_BANK_REFERENCE_DOWNLOADREFERENCE:
    '/sura/pay/:paymentLinkId/payment-methods/bank-reference/download-reference',
  SURA_CHECKOUT_PAYMENT_SUCCESS: '/sura/pay/:paymentLinkId/payment-success',
  SURA_CHECKOUT_SEND_REFERENCE: '/sura/pay/:paymentLinkId/payment-methods/send-reference',
  CHECKOUT_CARD: '/pay-card/:uuid',
  NOT_FOUND: '/404',
  DELETED: '/deleted',
  PROCESSING: '/processing',
  ACCOUNT_PAYABLES: '/accounts-payable/:accountsPayableLinkId',
};
